"use client";
import { Button, Page, Status } from "../components/ui";

/** S-21 サーバーのエラー（次にすることを示す） */
export default function ErrorPage({ reset }: { error: Error; reset: () => void }) {
  return (
    <Page title="うまく表示できませんでした" lead="一時的な不具合の可能性があります。少し時間をおいて、もう一度お試しください。">
      <Status tone="error">何度も続くときは、お手数ですが窓口までご連絡ください。</Status>
      <Button variant="primary" block onClick={reset}>もう一度読み込む</Button>
    </Page>
  );
}
